import * as yup from 'yup'

export class VehicleCheckInVINOnDashboardPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInVINOnDashboardPhotoFile?: File = undefined
}

export const vehicleCheckInVINOnDashboardPhotoValidationSchema = yup.object({
  vehicleCheckInVINOnDashboardPhotoFile: yup.mixed().notRequired()
})
